import { useContext, useMemo, useState } from "react";
import { AvisContext } from "../../context";
import { AvisConfirmModalShort } from "./AvisConfirmModalShort";
import { AvisMultiline } from "../inputs";

interface IAvisConfirmWithCommentModalProps {
  title: string;
  contentText: string;
  isOpen: boolean;
  disabled: boolean;
  onConfirm: (comment: string | undefined) => void;
  onClose: () => void;
}
export function AvisConfirmWithCommentModal(
  props: Readonly<IAvisConfirmWithCommentModalProps>,
) {
  const { title, contentText, isOpen, disabled, onConfirm, onClose } = props;
  const { res } = useContext(AvisContext);
  const [comment, setComment] = useState<string | undefined>();

  const onConfirmInner = () => {
    onConfirm(comment);
  };

  const renderContent = useMemo(
    () => (
      <div className="confirm-modal-with-comment">
        <div className="message">{contentText}</div>
        <div className="comment">
          <AvisMultiline
            label={res("label_Comment")}
            rows={2}
            value={comment}
            disabled={disabled}
            maxLength={500}
            onChange={(e) => {
              setComment(e);
            }}
          />
        </div>
      </div>
    ),
    [comment, contentText, disabled, res],
  );

  return (
    <AvisConfirmModalShort
      title={title}
      isOpen={isOpen}
      confirm={onConfirmInner}
      cancel={onClose}
      disableControls={disabled}
      content={renderContent}
    />
  );
}
